import type { Build } from "../types/build";

type StoredRun = {
  id?: unknown;
  name?: unknown;
  repository?: unknown;
  runId?: unknown;
};

export function getGitHubWorkflowUrl(build: Build) {
  let run: StoredRun | null = null;
  try {
    run = build.run_json ? (JSON.parse(build.run_json) as StoredRun) : null;
  } catch {
    return null;
  }

  if (typeof run?.name !== "string" || run.name.toLowerCase() !== "github") {
    return null;
  }

  const repository =
    build.repository ??
    (typeof run.repository === "string" ? run.repository : null);
  const runId = run.runId ?? run.id;
  if (
    !repository ||
    !/^[^/\s]+\/[^/\s]+$/.test(repository) ||
    (typeof runId !== "string" && typeof runId !== "number") ||
    !/^\d+$/.test(String(runId))
  ) {
    return null;
  }

  return `https://github.com/${repository}/actions/runs/${runId}`;
}
